import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePT from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterOutlet } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthStatePersistenceService, I18nConfig, I18nModule, provideConfig } from '@spartacus/core';
import { AppRoutingModule } from '@spartacus/storefront';
import { CustomAuthStatePersistenceService } from './core/services/custom-auth-state-persistence.service';
import { SpartacusModule } from './spartacus/spartacus.module';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BaseTmsModule, TmsConfig } from '@spartacus/tracking/tms/core';
import { GtmModule } from '@spartacus/tracking/tms/gtm';
import { translationChunksConfig, translations } from '../assets/translations/translations';
import { environment } from '../environments/environment';
import { NDBSRecaptchaModule } from './core/recaptcha/recaptcha.module';
import { primeNGThemeConfig } from './primeng.theme.config';
import { ProductAuxStoreModule } from './spartacus/features/product/_core/store/product-aux.store.module';
import { ThemeStoreModule } from './spartacus/features/store-front/misc/theme/core/store/theme-store.module';
import { CustomStoreFrontComponent } from './spartacus/features/store-front/store-front.component';
import { UserAuxStoreModule } from './spartacus/features/user/core/store/user-aux.store.module';

registerLocaleData(localePT);

@NgModule({
  imports: [
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    I18nModule,
    CustomStoreFrontComponent,
    GtmModule,
    BaseTmsModule.forRoot(),
    RouterOutlet,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    ThemeStoreModule,
    ProductAuxStoreModule,
    UserAuxStoreModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    NDBSRecaptchaModule.forRoot(),
    SpartacusModule,
  ],
  providers: [
    { provide: AuthStatePersistenceService, useExisting: CustomAuthStatePersistenceService },
    provideConfig(<I18nConfig>{
      i18n: {
        resources: translations,
        chunks: translationChunksConfig,
      },
    }),
    provideConfig({
      routing: {
        routes: {
          product: { paths: ['product/:productCode/:catalogNumber/:slug'] },
        },
      },
    }),
    provideConfig({
      tagManager: {
        gtm: {
          gtmId: environment.googleAnalyticsId,
          events: [],
        },
      },
    } as TmsConfig),
    primeNGThemeConfig.providers,
  ],
})
export class AppModule {}
